<template>
<div v-loading.fullscreen.lock="fullscreenLoading">

    <!--コンテンツ-->
    <main id="renew2_mypage">
        <div class="yagioffer_container">
            <div class="renew2_wrapper renew2_flex">
                <div class="servicelist">
                    <ul class="servicelist__block renew2_pc">
                        <li class="servicelist__item waiting"><a href="/mypage"><img src="/static/renew2_img/icon_mypagetop.svg" alt="マイページ"><br>マイページ</a></li>
                        <li class="servicelist__item onclick"><a href="/mypage/yagioffer"><img src="/static/renew2_img/icon_yagioffer.svg" alt="ヤギオファー"><br>ヤギオファー</a></li>
                        <li class="servicelist__item waiting"><a href="/mypage/quickmail"><img src="/static/renew2_img/icon_quickmail.svg" alt="ヤギの宅配便"><br>ヤギの宅配便</a></li>
                        <li class="servicelist__item waiting"><a href="/mypage/quickemail"><img src="/static/renew2_img/icon_quickemail.svg" alt="ヤギのメール便"><br>ヤギのメール便</a></li>
                        <li class="servicelist__item waiting"><a href="/mypage/introduction"><img src="/static/renew2_img/icon_recommend.svg" alt="推薦・紹介文"><br>推薦・紹介文</a></li>
                    </ul>
                    <div class="renew2_sp">
                        <ul class="servicelist__block renew2_sp_flex">
                            <li class="servicelist__item onclick"><a href="/mypage/yagioffer"><img src="/static/renew2_img/icon_yagioffer.svg" alt="ヤギオファー"><br>ヤギオファー</a></li>
                            <li class="servicelist__item waiting"><a href="/mypage/quickmail"><img src="/static/renew2_img/icon_quickmail.svg" alt="ヤギの宅配便"><br>ヤギの宅配便</a></li>
                            <li class="servicelist__item waiting"><a href="/mypage/quickemail"><img src="/static/renew2_img/icon_quickemail.svg" alt="ヤギのメール便"><br>ヤギのメール便</a></li>
                            <li class="servicelist__item waiting"><a href="/mypage/introduction"><img src="/static/renew2_img/icon_recommend.svg" alt="推薦・紹介文"><br>推薦・紹介文</a></li>
                        </ul>
                    </div>
                </div>
                <div class="mypage_contents">
                    <div class="renew2_flex lead">
                        <h2>ヤギオファー</h2>
                        <a href="/yagiofferhelp" target="_blank" class="" v-if="false">ヤギオファーについて</a>
                    </div>
                    <p>採用を行なっている会社からオファーが届きます。</p>
                    <p class="memo">※名前や住所等の個人情報はオファーを承諾するまで求人会社は見ることができません。<br>
                    </p>
                    <p class="memo">※オファーを受けたくない場合は <a href="/account/delete">こちら</a><br>
                    </p>
                    <div class="yagioffer_block">
                        <p class="not_used">現在、利用履歴はありません。</p>
                        <ul class="yagioffer_block__list">

                            <li class="renew2_flex yagioffer_block__item" v-for="(item, index) in yagiOfferData.offer_list" :key="index">
                                <div class="status renew2_flex renew2_sp_flex">
                                    <p class="date">{{item.offer_date}}</p><!--日付-->

                                    <p v-if="item.offer_status=='accept'" class="offer_status status_approved">承認</p>
                                    <p v-else-if="item.offer_status=='refuse'" class="offer_status status_decline">辞退</p>
                                    <p v-else class="offer_status status_undecided">未定</p>
                                    <a :href="chatURL" class="mes-unread" target="_blank"
                                    v-for="(m_item, m_index) in yagiOfferUnreadmessageList" :key="m_index"
                                    v-if="item.offer_status=='accept' && m_item.id == item.company_uid"
                                    ><span>{{m_item.unreadCount}}</span></a>

                                </div>
                                <p class="company">{{item.company_name}}</p>

                                <div v-if="!item.detail_display" class="confirmation_btn" @click="!item.detail_display?item.detail_display=true:item.detail_display=false;openYagiOfferDetailDialog(item.offer_id, '0')">
                                    <label for="confirmation1" class="confirmation">確認</label>
                                </div>
                                <div v-else class="confirmation_btn" @click="!item.detail_display?item.detail_display=true:item.detail_display=false">
                                    <label for="confirmation1" class="confirmation"><i class="el-icon-circle-close-outline"></i> 閉じる</label>
                                </div>


                                <div class="dropdown1" v-if="item.detail_display">
                                    <div class="renew2_flex dropdown_box">
                                        <p class="dropdown_company">企業名：<span>{{item.company_name}}</span></p>
                                        <div class="dropdown_link">
                                            <a v-if="item.company_url" :href="item.company_url" target="_blank" class="dropdown_link__site">企業HP</a>
                                            <a v-if="item.offer_attach_link1" :href="item.offer_attach_link1" target="_blank">添付した資料</a>
                                            <a v-if="item.offer_attach_link2" :href="item.offer_attach_link2" target="_blank">添付した資料</a>
                                            <a v-if="item.offer_attach_link3" :href="item.offer_attach_link3" target="_blank">添付した資料</a>
                                        </div>
                                    </div>
                                    <img v-if="item.company_logo" :src="item.company_logo" alt="会社ロゴ" class="dropdown_link__logo">
                                    <p class="dropdown_message"><pre style="font-family: M PLUS Rounded\ 1c,sans-serif;white-space: pre-wrap;overflow-y: scroll;">{{item.offer_message}}</pre></p>

                                    <div class="reply_btn" v-if="item.offer_status=='send'">
                                      <el-button id="submit_offer" type="success"  class="offer_approved"
                                        @click="submitOffer(item.offer_id)">まずは話を聞いてみる</el-button>
                                      <br>
                                      <el-button id="deny_offer" type="success" class="offer_decline"
                                        @click="denyOffer(item.offer_id)">辞退する</el-button>
                                    </div>
                                </div>
                            </li>



                        </ul>
                    </div>
                    <div class="content-wrapper" style="width:100%;" v-if="chatURL && yagiOfferData.offer_list.length > 0">
                      <a :href="chatURL" class="mes-confirm" target="_blank" >チャットする</a>
                    </div>
                    <div class="renew2_sp">
                        <a href="/mypage" class="servicelist__mypage"><img src="/static/renew2_img/icon_mypagetop.svg" alt="マイページ">マイページに戻る</a>
                    </div>
                </div>
            </div>
        </div>
    </main>

</div>
</template>

<style lang="css" src="@/assets/css/renew2_mypage.css"></style>


<style scoped>
  #renew2_mypage .yagioffer_container .mypage_contents .mes-confirm {
    background: #fff;
    padding: 10px 30px;
    width: 50%;
    border-radius: 40px;
    border: 1px solid #e3165c;
  }
  #renew2_mypage .yagioffer_container .mypage_contents .mes-confirm::before {
    display: none;
  }
  #renew2_mypage .yagioffer_container .mypage_contents .yagioffer_block__list .mes-unread{
      font-size: 0.7rem;
      font-weight: bold;
      color: #fff;
      background: #E95B10;
      display: inline-block;
      padding: 2px 8px;
      margin-right: 5px;
      border-radius: 20px;
      width: auto;
      text-align: center;
  }
  #renew2_mypage .yagioffer_container .mypage_contents .yagioffer_block__list .mes-unread::before{
    display: none;
  }
</style>



<script>
import {
  TabPane,
  Tabs,
  MessageBox
} from 'element-ui'
import LoginForms from '@/components/RenewLoginForms'
import firebase from 'firebase/app'

export default {
  components: {
    'login-forms': LoginForms
  },
  data: function () {
    return {
		  fullscreenLoading: true,
      recentEdit: {
        FormatId: ''
      },
      dialogVisible:false,
      selectedYagiOfferData:{},
      yagiOfferData: [],
      previewLoading: false,
      yagiOfferUnreadmessageList: [],
      chatURL: ''
    }
  },
  computed: {
    getMode: function () {
      return process.env.VUE_APP_MODE
    }
  },
  methods: {
    openYagiOfferDetailDialog: function (offer_id, read_flag) {
      const app = this
      if (read_flag != '1') {
        const app = this
        const formData = new FormData()
        formData.append('offer_id', offer_id)
        formData.append('uuid', app.$firebase.user.uid)

        this.$axios
          .post(this.$varuna.endPoints.readYagiOffer, formData, {timeout: 60000})
          .then(function (response) {
            for(let _item of app.yagiOfferData.offer_list){
              if (_item.offer_id == offer_id) {
                _item.read_flag = '1'
              }
            }
          })
          .catch(function (error) {})
          .finally(function () {})
      }
    },
    submitOffer: function (offer_id) {
      const app = this
      const formData = new FormData()
      formData.append('offer_id', offer_id)
      formData.append('uuid', app.$firebase.user.uid)

      this.$axios
        .post(this.$varuna.endPoints.submitYagiOffer, formData, {timeout: 60000})
        .then(function (response) {
          for(let _item of app.yagiOfferData.offer_list){
            if (_item.offer_id == offer_id) {
              _item.offer_status = 'accept'
            }
          }
          app.$message({
            duration: 3000,
            showClose: true,
            dangerouslyUseHTMLString: true,
            message: `オファーを承認しました`,
            type: 'success'
          })
        })
        .catch(function (error) {
          app.$message({
            duration: 3000,
            showClose: true,
            dangerouslyUseHTMLString: true,
            message: `オファーの承認処理を失敗しました`,
            type: 'error'
          })
        }).finally(function () {
          
        })
      console.error(this.selectedYagiOfferData.offer_id)
    },
    denyOffer: function (offer_id) {
      const app = this
      const formData = new FormData()
      formData.append('offer_id', offer_id)
      formData.append('uuid', app.$firebase.user.uid)

      this.$axios
        .post(this.$varuna.endPoints.denyYagiOffer, formData, {timeout: 60000})
        .then(function (response) {
          for(let _item of app.yagiOfferData.offer_list){
            if (_item.offer_id == offer_id) {
              _item.offer_status = 'refuse'
            }
          }
          app.$message({
            duration: 3000,
            showClose: true,
            dangerouslyUseHTMLString: true,
            message: `オファーを辞退しました`,
            type: 'success'
          })
        })
        .catch(function (error) {
          app.$message({
            duration: 3000,
            showClose: true,
            dangerouslyUseHTMLString: true,
            message: `オファーの辞退処理を失敗しました`,
            type: 'error'
          })
        }).finally(function () {
          
        })
      console.error(this.selectedYagiOfferData.offer_id)
    }
  },
  created: function () {
    const app = this
    // console.log(this.$route.query.mynavi)
    firebase.auth().onAuthStateChanged((user) => {
      if (user) {    
        console.log('logined')
        const formData = new FormData()
        formData.append('access_id', '')
        formData.append('uuid', app.$firebase.user.uid)
        formData.append('device_flg', app.$deviceLib.isMobileDevice ? 'SP': 'PC')
        formData.append('version', '2')
        formData.append('reqflg', '2')
        this.$axios
          .post(this.$varuna.endPoints.getYagiOfferList, formData, {timeout: 60000})
          .then(function (response) {
            app.yagiOfferData = response.data
          })

        this.$axios
          .post(this.$varuna.endPoints.getMessageBox, formData, {timeout: 60000})
          .then(function (response) {
            app.yagiOfferUnreadmessageList = response.data.unreadcnts.data.companyList
            app.chatURL = response.data.chat_url
            console.error(app.chatURL)
          })
	      this.fullscreenLoading = false

      } else {
        this.$router.push('/login')
      }
    })
  },
  beforeMount: function () {
  },
  destroyed: function () {
  }
}
</script>
